import Vue from 'vue'
import VueRouter from 'vue-router'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  },
  {
    path: '/cas-login',
    name: 'cas-login',

    component: () => import( '../views/CasloginView.vue')
  },
  {
    path: '/list',
    name: 'list',

    component: () => import( '../views/ListMessage.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import( '../views/LoginView.vue'),
    meta:{
      hiddleNav: true
    }
  },
  {
    path: '/user',
    name: 'user',

    component: () => import( '../views/UserView.vue')
  },
  
  {
    path: '/IPRang',
    name: 'IPRang',

    component: () => import( '../views/IPRangView.vue')
  },
  {
    path: '/IP',
    name: 'IP',

    component: () => import( '../views/IPView.vue')
  },
  {
    path: '/IPSW',
    name: 'IPSW',

    component: () => import( '../views/IPSWView.vue')
  },
  {
    path: '/IPSchool',
    name: 'IPSchool',

    component: () => import( '../views/IPSchoolView.vue')
  },
  {
    path: '/test_mu',
    name: 'test_mu',

    component: () => import( '../views/test_mu.vue')
  },
  
  {
    path: '/chat',
    name: 'chat',

    component: () => import( '../views/Chat2view.vue')
  },
]

const router = new VueRouter({
  mode:'history',
  routes
})

export default router
